import React from 'react';

const LassoInverseIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16pt" height="16pt" viewBox="0 0 64 64" className="svg-icon lasso-inverse-icon" {...props}>
        <rect
            style={{stroke: 'none', fill: '#b3b3b3'}}
            width="66.983047"
            height="65.355934"
            x="-1.0847458"
            y="-0.40677971"/>
        <g
            transform="matrix(0.83050847,0,0,0.83050847,5.4696926,5.6075841)">
            <ellipse
                ry="19.661016"
                rx="31.322035"
                cy="26.440678"
                cx="32.271187"
                id="path3356"
                style={{stroke: 'none', fill: '#ffffff'}}/>
            <path
                style={{fill: '#000000'}}
                d="m 32.271186,6.0847455 c -17.645,0 -31.99999942,9.1960005 -31.99999942,20.5000005 0,7.923 7.05800002,14.806 17.35299942,18.217 -2.022,0.867 -3.353,2.442 -3.353,4.283 0,2.804 3.075,5 7,5 1.458,0 2.799,-0.305 3.909,-0.829 0.433,0.394 1.091,1.246 1.091,2.829 0,1.841 -0.857,1.989 -1,2 l 0,2 c 1.038,0 3,-0.836 3,-4 0,-1.952 -0.729,-3.212 -1.409,-3.966 0.884,-0.837 1.409,-1.883 1.409,-3.034 0,-0.805 -0.26,-1.557 -0.715,-2.225 1.54,0.147 3.113,0.225 4.715,0.225 17.645,0 31.999999,-9.196 31.999999,-20.5 0,-11.304 -14.354999,-20.5000005 -31.999999,-20.5000005 z m -16,43.0000005 c 0,-1.626 2.29,-3 5,-3 2.71,0 5,1.374 5,3 0,1.626 -2.29,3 -5,3 -2.71,0 -5,-1.374 -5,-3 z m 16,-4 c -16.542,0 -29.9999994,-8.299 -29.9999994,-18.5 0,-10.201 13.4579994,-18.5000005 29.9999994,-18.5000005 16.542,0 29.999999,8.2990005 29.999999,18.5000005 0,10.201 -13.457999,18.5 -29.999999,18.5 z"/>
        </g>
    </svg>
);

export default LassoInverseIcon;



// WEBPACK FOOTER //
// ./src/components/LassoInverseIcon.js